import React, {
  useCallback, useContext, useEffect, useMemo,
} from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, useTheme } from '@material-ui/core';
import {
  Receipt as ReceiptIcon,
  MoreHoriz as MoreHorizIcon,
  CheckCircle as CheckCircleIcon,
  CancelOutlined as CancelOutlinedIcon,
  Refresh as RefreshIcon,
  RotateLeft as RotateLeftIcon,
  Delete as DeleteIcon,
  Search as PageviewIcon,
} from '@material-ui/icons';
import SimpleConsultPageTemplate from '../../../../templates/simple-consult-page/SimpleConsultPageTemplate/SimpleConsultPageTemplate';
import useOperationController from '../../../../utils/hooks/store/operation/useOperationController';
import { isAlternativeLoadingStatus } from '../../../../utils/store/store-utils';
import AereoContext from '../../../../contexts/agenciamento/house/HouseContext';
import { selectAereos,fetchAllAsync, selectHouseType ,resetMode,resetModel,changeToCreateMode, selectOperationHouse} from '../../../../features/house/HouseSlice';
import { getBreadcrumbsOfHouse, getTitleOfHouse } from '../../../../features/house/houseUtils';
import { userHasDeleteRole } from '../../../../components/perfil/perfil-utils';

export default function HouseConsultPage({ authInfo = {} }) { 
  
  const { t } = useTranslation();

  const history = useHistory()

  const dispatch = useDispatch();

  const type = useSelector(selectHouseType);
  const operation = useSelector(selectOperationHouse);

  const theme = useTheme();

  const { status } = useContext(AereoContext);

  const aereo = useSelector(selectAereos);

  const resetModes = useCallback(() => {
    dispatch(resetMode());
  }, []);

  const fetchAll = useCallback(() => {
    dispatch(fetchAllAsync([{ name: 'operacao', value: operation }]));
  }, []);

  const resetModels = useCallback(() => {
    dispatch(resetModel());
  }, []);

  const getMoedaDescription = (row) => row?.custos?.[0]?.moeda?.description ?? "-";

  const breadcrumbs = [
    {
      link: {
        to: '/',
        name: t('com.muralis.qcx.inicio'),
      },
    },
    {
      link: {
        to: operation === 'EXPORTACAO' ? t('com.muralis.qcx.url.moduloAgenciamentoExportacao') : t('com.muralis.qcx.url.moduloAgenciamento'),
        name: operation === 'EXPORTACAO' ? t('com.muralis.qcx.exportacao.label') : t('com.muralis.qcx.importacao.label'),
      },
    },
    {
      link: {
        to: t('com.muralis.qcx.url.importacao.label'),
        name: t('com.muralis.qcx.desembaraco'),
      },
    },
    {
      text: {
        name: getBreadcrumbsOfHouse(type),
      },
    },
  ];

  useEffect( () => {
    console.log(type);
    console.log(operation)
  },[type]);

  useEffect( () => {
    fetchAll();
    resetModes();
    resetModels();
  }, []);
  
  const handleClickOnEditButton = useCallback( (event, id) => {
    event.stopPropagation();
    history.push(t('com.muralis.qcx.url.moduloAgenciamentoHouseConsultar', { id }));
  },[history])

  const handleActivateInactivate = useCallback((event, id) => {

  },[]);


  const isAlternativeLoading = useMemo(() => (
    isAlternativeLoadingStatus(status)
  ), [status]);

  const columns = [
    {
      field: 'processo',
      align: 'center',
      headerName: t('com.muralis.qcx.aereo.table.processo'),
      headerAlign: 'center',
      type: 'string',
      flex: 60,
      valueGetter: ({ row }) => (
        row?.numeroProcesso
      ),
    },
    {
      field: 'cliente',
      headerName: t('com.muralis.qcx.aereo.table.cliente'),
      headerAlign: 'center',
      align: 'center',
      type: 'string',
      flex: 60,
      valueGetter: ({ row }) => (
        row?.cliente?.description ?? "-"
      ),
    },
    {
      field: 'consignatario',
      headerName: t('com.muralis.qcx.aereo.table.consignatario'),
      headerAlign: 'center',
      align: 'center',
      type: 'string',
      flex: 60,
      valueGetter: ({ row }) => (
        row?.consignatario?.description ?? "-"
      ),
    },
    {
      field: 'origem',
      headerName: t('com.muralis.qcx.aereo.table.origem'),
      headerAlign: 'center',
      align: 'center',
      type: 'string',
      flex: 80,
      valueGetter: ({ row }) => (row?.origem?.description ?? "-"),
    },
    {
      field: 'destino',
      headerName: t('com.muralis.qcx.aereo.table.destino'),
      headerAlign: 'center',
      align: 'center',
      type: 'string',
      flex: 80,
      valueGetter: ({ row }) => (row?.destino?.description ?? "-"),
    },
    {
      field: 'moeda',
      headerName: t('com.muralis.qcx.aereo.table.moeda'),
      headerAlign: 'center',
      align: 'center',
      type: 'string',
      flex: 80,
      valueGetter: ({ row }) => (getMoedaDescription(row)),
    },
    {
      field: 'embarque',
      headerName: t('com.muralis.qcx.aereo.table.embarque'),
      headerAlign: 'center',
      align: 'center',
      type: 'string',
      flex: 80,
      valueGetter: ({ row }) => (
        row?.description
      ),
    },
    {
      field: 'ativo',
      headerName: 'Ativo',
      headerAlign: 'center',
      align: 'center',
      type: 'boolean',
      flex: 80,
      valueGetter: ({ row }) => (
        row?.active
      ),
    },
    {
      field: 'actions',
      headerName: t('com.muralis.qcx.acoes.label'),
      headerAlign: 'center',
      align: 'center',
      flex: 80,
      renderCell: ({ row: { id, active } }) => (
        <>
          {userHasDeleteRole(authInfo, 'grupo-despesa-receita') && (
          <IconButton
            key={`stw-active${id}`}
            value={active}
            name={`stw-active-${id}`}
            onClick={(event) => handleActivateInactivate(event, id)}
          >
            <DeleteIcon color="error" />
          </IconButton>
          )}
          <IconButton
            key={`btn-view-${id}`}
            name={`btn-view-${id}`}
            onClick={(event) => handleClickOnEditButton(event, id)}
          >
            <PageviewIcon color="primary" />
          </IconButton>
        </>
      ),
    },  
  
  ];

  const handleClickOnButtonNew = useCallback((event) => {
    event.stopPropagation();
    dispatch(changeToCreateMode());
  }, []);

  const templateProps = {
    page: {
      title: getTitleOfHouse(type),
      breadcrumbs,
    },
    control: {
      buttonNew: {
        description: t('com.muralis.qcx.aereo.novoCadastro'),
        path: t('com.muralis.qcx.url.importacaoAereoNovo'),
        onClick: handleClickOnButtonNew,
      },
    },
    table: {
      columns,
    },
  };

  return (
      <SimpleConsultPageTemplate 
            pageProps={templateProps.page}
            controlProps={templateProps.control}
            tableProps={templateProps.table}
            tableData={aereo ?? []}
            isLoading={isAlternativeLoading}
            buttonNewText={t('com.muralis.qcx.acoes.nova').toUpperCase()}
            multipleFilter
            authInfo={authInfo}
      />
  );
}